import { BaseUserWithRole } from '@sb-tools/typescript/models/base-user-with-role.model';
import { MessageThreadElementType } from '@sb-tools/typescript/enums/message-thread-element-type.enum';
import { SessionAuthenticationLevel } from '@sb-tools/typescript/enums/session-authentication-level.enum';

export interface SessionAuthenticationEventDTO {
    creationTime: Date | string;
    eventType: SessionAuthenticationEventType;
    id: number;
    level: SessionAuthenticationLevel | null;
    ticketId: number;
    type: MessageThreadElementType.sessionAuthentication;
    user: BaseUserWithRole | null;
}

export enum SessionAuthenticationEventType {
    escalationRequested = 1,
    levelUpdated = 2,
}
